import { render, staticRenderFns } from "./AlertsRoutingStatus.vue?vue&type=template&id=53abc0a6&scoped=true&"
import script from "./AlertsRoutingStatus.vue?vue&type=script&lang=js&"
export * from "./AlertsRoutingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53abc0a6",
  null
  
)

export default component.exports